<template>
  <div class="card payment-card">
    <div class="payment-form-header">
      <icon name="lock"></icon>
      <span>{{ $t('payment.cardEncrypt') }}</span>
    </div>
    <div class="padding-a-m">
      <h2 class="margin-a-z margin-b-s">{{ $t('rsvpEdit.paymentInfo')}}</h2>

      <form v-on:submit.prevent="submitPayment">
        <div v-if="showPaymentDropdown">
          <div :class="['field-group pad-b' + (validation.paymentMethod? '': ' field-error')]">
            <select class="field-text field-select" v-model="selectedPayment" v-on:change="onPaymentSelect">
              <option disabled value="-1">{{ $t('payment.selectCard') }}</option>
              <option value="directBill" v-if="isCorporate">{{ $t('payment.directBill') }}</option>
              <option v-for="(payment, i) in existingPayments" :value="payment.id" :key="i">
                {{ payment.number + ' (Exp: ' + payment.exp + ') - ' + payment.type }}
              </option>
              <option value="0">{{ $t('payment.useNew') }}</option>
            </select>
            <label class="field-error-message">{{ $t('payment.selectPayment') }}</label>
          </div>
        </div>

        <div ref="NewPaymentForm" class="row margin-t-s">
          <div v-if="useStripeForm" class="column">
            <stripe-payment-form v-show="!isPaymentFormHidden" ref="stripeForm"
              @failed="failedSubmitStripe" @done="doneSubmitStripe"
            ></stripe-payment-form>
          </div>

          <div class="clear"></div>

          <div :class="['alert-wrap showhide-fadeslide' + (showCreditCardError ? '':' hide')]">
            <div class="small-12 columns">
              <div class="alert error margin-t-m">
                {{ creditCardError }}
              </div>
            </div>
          </div>

          <div class="d-flex justify-space-between column" v-if="false">
            <div class="page-actions-wrap">
              <a href="#/customer" class="op-btn btn-lg btnBack" @click="back($event)">
                <icon name="chevron-left" class="margin-r-xs"></icon>
                {{ $t('common.back') }}
              </a>
              <label class="margin-t-xs">
                <span>{{ $t('payment.previous') }}:</span>
                {{ $t('payment.yourInfo') }}
              </label>
            </div>
            <div class="page-actions-wrap text-right">
              <a href="#/review" :class="['op-btn btn-success btn-lg btnContinue', {loading:isSubmittingForm}]"
                @click="submitForm($event)">
                <div class="original-label">
                  {{ $t('common.continue') }}
                  <icon name="chevron-right" class="margin-l-xs"></icon>
                </div>
                <div class="loaderx">
                  <icon name="refresh" spin class="magin-r-xs"></icon>
                  {{ $t('payment.validating') }}
                </div>
              </a>
              <button type="submit" ref="submitBtn" v-show="false"></button>
              <label class="margin-t-xs">
                <span>{{ $t('common.next') }}:</span>
                {{ $t('payment.reviewBook') }}
              </label>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueCookie from 'vue-cookie'
import US from 'us'
// import Countries from '@/data/countries.js'
import creditCardType, { types as CardType } from 'credit-card-type'
import StripePaymentForm from './StripePaymentForm.vue'

Vue.use(VueCookie);

export default {
  name: 'payment-form',
  props: [ 'user', 'flash', 'cards' ],
  directives: {
    'click-outside': {
      bind (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
          if (compName) { warn += `Found in component '${compName}'` }

          console.warn(warn)
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler

        // add Event Listeners
        document.addEventListener('click', handler)
      },

      unbind (el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null
      }
    }
  },
  components: { StripePaymentForm },
  data () {
    return {
      title: 'Payment Information',
      showPaymentDropdown: true,
      isPaymentFormHidden: true,
      isSubmittingForm: false,
      showCountry: false,
      creditCardError: '',
      showCreditCardError: false,
      showCvvInfo: false,
      validation: {
        paymentMethod: true,
        cardName: true,
        cardNumber: true,
        cardExp: true,
        cardCvv: true,
        cardAddress: true,
        cardCity: true,
        cardState: true,
        cardZip: true,
        cardCountry: true
      },
      validationMsg: {
        cardExp: this.$t('payment.isRequired')
      },
      card: {
        title: '',
        name: '',
        number: '',
        exp: '',
        cvv: '',
        billingAddress: '',
        billingCity: '',
        billingState: '-1',
        billingZip: '',
        billingCountry: '-1'
      },
      paymentMethods: {
        visa: '',
        mastercard: '',
        amex: '',
        discover: '',
        jcb: '',
        dinersclub: ''
      },
      existingPayments: [],
      selectedPayment: this.$store.state.selectedCard.id,
      useStripeForm: true
    }
  },
  computed: {
    states () {
      let result = [{name: 'Non US', value: ''}]

      let states = US.STATES
      for (let i = 0; i < states.length; i++) {
        result.push({
          name: states[i].name,
          value: states[i].abbr
        })
      }

      return result
    },
    // countries () {
    //   let result = []
    //   for (let property in Countries) {
    //     if (!Countries.hasOwnProperty(property) || property === 'us') continue

    //     result.push({
    //       name: Countries[property].name,
    //       value: property.toUpperCase()
    //     })
    //   }

    //   return result
    // },
    userStore () { return this.$store.state.user },
    _token () { return this.userStore.token },
    isCorporate () { return this.userStore.isCorporate },
    bookingType () { return this.$store.state.reservation.bookingType },
    booking () { return this.$store.state.booking },
    bookingAsGuest () { return this.booking.bookAsGuest },
    _cards () { return this.$store.state.cards.list }
  },
  methods: {
    clearValidation () {
      this.validation.paymentMethod = true
      this.validation.cardName = true
      this.validation.cardNumber = true
      this.validation.cardExp = true
      this.validation.cardCvv = true
      this.validation.cardAddress = true
      this.validation.cardCity = true
      this.validation.cardState = true
      this.validation.cardZip = true
      this.validation.cardCountry = true
    },
    validatePaymentForm () {
      let self = this
      let card = self.card
      let result = true;

      self.clearValidation()

      if (card.name === '') {
        self.validation.cardName = false
        result = false
      }

      let cardInfo = creditCardType(card.number);
      if (cardInfo.length !== 1) {
        self.validation.cardNumber = false
        result = false
        card.title = '';
      } else {
        card.title = cardInfo[0].niceType;
      }

      // expiration validation
      if (card.exp === '') {
        self.validation.cardExp = false
        self.validationMsg.cardExp = self.$t('payment.isRequired')
        result = false
      }

      if (card.exp !== '') {
        // check format
        let expTokens = card.exp.split('/')
        if (expTokens.length < 2 ||
            expTokens[0].length !== 2 ||
            expTokens[1].length !== 4) {
          self.validation.cardExp = false
          self.validationMsg.cardExp = `${self.$t('payment.followFormat')} MM/YYYY.`
          result = false
        }

        let expMonth = Number(expTokens[0])
        if (expMonth < 1 || expMonth > 12) {
          self.validation.cardExp = false
          self.validationMsg.cardExp = self.$t('payment.invalidExp')
          result = false
        }

        let d = new Date()
        let currentYear = d.getFullYear()
        let expYear = Number(expTokens[1])
        if (expYear < currentYear) {
          self.validation.cardExp = false
          self.validationMsg.cardExp = self.$t('payment.futureDate')
          result = false
        }

        let currentMonth = d.getMonth() + 1;
        if (expYear === currentYear && expMonth < currentMonth) {
          self.validation.cardExp = false
          self.validationMsg.cardExp = self.$t('payment.futureDate')
          result = false
        }
      }
      // expiration end

      if (card.cvv === '') {
        self.validation.cardCvv = false
        result = false
      }

      if (card.billingAddress === '') {
        self.validation.cardAddress = false
        result = false
      }

      if (card.billingCity === '') {
        self.validation.cardCity = false
        result = false
      }

      if (card.billingState === '-1') {
        self.validation.cardState = false
        result = false
      }

      /*
      if (card.billingZip === '') {
        self.validation.cardZip = false
        result = false
      }
      */

      if (card.billingState === '' && card.billingCountry === '-1') {
        self.validation.cardCountry = false
        result = false
      }

      return result
    },
    submitPayment () {
      this.clearValidation()
      this.isSubmittingForm = true;
      if (this.selectedPayment === -1) {
        this.validation.paymentMethod = false
        this.isSubmittingForm = false;
        this.$emit('done', false)
        return;
      }

      if (this.selectedPayment === '0' || this.selectedPayment === 0) {
        if (this.useStripeForm) {
          if (this.$refs.stripeForm.submitPayment()) {
            this.$refs.stripeForm.submitPayment()
          }
          return
        }
        let isValid = this.validatePaymentForm()

        if (!isValid) {
          this.isSubmittingForm = false;
          this.$emit('done', false)
          return
        }

        this.$root.$emit('addCard', {
          title: this.card.title,
          number: this.card.number,
          expiration: this.card.exp,
          name: this.card.name,
          cvv: this.card.cvv,
          billingAddress: this.card.billingAddress,
          billingCity: this.card.billingCity,
          billingState: this.card.billingState,
          billingCountry: this.card.billingCountry,
          billingZip: this.card.billingZip,
          token: this.$store.state.user.token
        })

        return
      }

      this.isSubmittingForm = false;
      let selectedCard = {};
      for (let i = 0; i < this.existingPayments.length; i++) {
        if (this.existingPayments[i].id === this.selectedPayment) {
          selectedCard = this.existingPayments[i]
          break;
        }
      }
      this.$store.commit('setSelectedCard', selectedCard)
      this.trackPaymentData()
      if (['flight', 'sightSeeing', 'hotel'].indexOf(this.bookingType) > -1) {
        this.$emit('done', true)
        // this.$root.$router.push('review-summary')
      } else {
        this.$root.$router.push('review')
      }
    },
    onPaymentSelect () {
      this.$emit('changeCard', this.selectedPayment)
      this.clearValidation()
      if (this.selectedPayment === '0') {
        this.isPaymentFormHidden = false
        this.clearValidation()
        this.$scrollTo(this.$refs.NewPaymentForm)
      } else {
        this.isPaymentFormHidden = true
      }
      this.$store.commit('user/setIsDirectBilling', this.selectedPayment === 'directBill')

      if (window.gtag) { // eslint-disable-line
        gtag( // eslint-disable-line
          'event',
          'Payment_Method',
          {value: this.selectedPayment === '0' ? 'New Credit Card' : 'Use Existing Card'}
        )
      }
    },
    onStateSelect () {
      this.showCountry = (this.card.billingState === '')
      if (this.showCountry) {
        this.card.billingCountry = '-1'
      }
    },
    toggleCvvInfo () {
      this.showCvvInfo = true
    },
    hideCvvInfo () {
      this.showCvvInfo = false
    },
    disableCards () {
      this.paymentMethods.visa = 'disabled';
      this.paymentMethods.mastercard = 'disabled';
      this.paymentMethods.amex = 'disabled';
      this.paymentMethods.discover = 'disabled';
      this.paymentMethods.jcb = 'disabled';
      this.paymentMethods.dinersclub = 'disabled';
    },
    enableCards () {
      this.paymentMethods.visa = '';
      this.paymentMethods.mastercard = '';
      this.paymentMethods.amex = '';
      this.paymentMethods.discover = '';
      this.paymentMethods.jcb = '';
      this.paymentMethods.dinersclub = '';
    },
    updateIcon () {
      let self = this;
      let cardNumber = self.card.number;
      let length = cardNumber.length;

      if (length === 0) {
        self.enableCards();
      } else {
        self.disableCards();
      }

      let possibleCards = creditCardType(cardNumber);

      for (let i = 0; i < possibleCards.length; i++) {
        let possibleCard = possibleCards[i];
        let cardType = possibleCard.type;

        if (cardType === CardType.VISA) {
          self.paymentMethods.visa = '';
        } else if (cardType === CardType.MASTERCARD) {
          self.paymentMethods.mastercard = '';
        } else if (cardType === CardType.AMERICAN_EXPRESS) {
          self.paymentMethods.amex = '';
        } else if (cardType === CardType.DINERS_CLUB) {
          self.paymentMethods.dinersclub = '';
        } else if (cardType === CardType.DISCOVER) {
          self.paymentMethods.discover = '';
        } else if (cardType === CardType.JCB) {
          self.paymentMethods.jcb = '';
        }
      }
    },
    isNumber (evt) {
      let charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault()
        return
      }
      return true;
    },
    isMax20 (evt) {
      if (this.card.billingZip.length >= 20) {
        evt.preventDefault()
        return
      }
      return true
    },
    formatDate () {
      let cardExp = this.card.exp
      if (cardExp.length === 2 && !isNaN(cardExp)) {
        this.card.exp = cardExp + '/'
      }
    },
    togglePaymentForm () {
      this.isPaymentFormHidden = !this.isPaymentFormHidden
    },
    parseCardClass (card) {
      let result = ''
      if (card.title === 'Visa') {
        result = 'visa'
      } else if (card.title === 'MasterCard' || card.title === 'Master Card') {
        result = 'mastercard'
      } else if (card.title === 'American Express') {
        result = 'amex'
      } else if (card.title === 'JCB') {
        result = 'jcb'
      } else if (card.title === 'Diners Club') {
        result = 'dinersclub'
      } else if (card.title === 'Discover') {
        result = 'discover'
      }
      return result
    },
    back (event) {
      if (event) event.preventDefault()

      if (this.bookingType === 'flight') {
        this.$root.$router.push('pax-info')
      } else {
        this.$root.$router.push('customer')
      }
      // window.location.href = '#/customer'
    },
    submitForm (event) {
      if (event) event.preventDefault()
      this.submitPayment()
      // if (this.$refs.submitBtn) {
      //   this.$refs.submitBtn.click()
      // }
    },
    trackPaymentData () {
      // if (window.opoliCNS) {
      //   let rsvpData = this.$store.state.reservation
      //   let leg1 = rsvpData.leg1
      //   let leg2 = rsvpData.leg2
      //   let segment = {
      //     key: 'Payment Page',
      //     'Leg 1': leg1.selectedService ? leg1.services[leg1.selectedService].prices[leg1.passenger + 1].price : '',
      //     'Leg 2': rsvpData.isRoundtrip && leg2.selectedService ? leg2.services[leg2.selectedService].prices[leg2.passenger + 1].price : '',
      //     'Total Price': '',
      //     'Pick Up Location': leg1.pickup.title,
      //     'Drop off Location': leg1.dropoff.title,
      //     'Flight Date': leg1.flightDate,
      //     'Pick Up Airline Info': `${leg1.airline} ${leg1.flightNo}`,
      //     'Service Type': leg1.selectedService ? leg1.services[leg1.selectedService].brandedName : '',
      //     'Pickup Type': leg1.pickupType,
      //     'Pickup Date': leg1.pickupDate,
      //     'Payment Payment Page_Abandonment': 'No',
      //     'Payment Page_Continue': 'Yes'
      //   }
      //   if (leg1.isAsap) {
      //     segment['Pickup Date'] = 'ASAP'
      //   }
      //   this.$store.commit('tracking/setOpoliCnsData', {
      //     // getTotal2: 'Payment Page'
      //     getTotal2: {
      //       key: 'Payment Page',
      //       segment: segment,
      //       url: null,
      //       widgetEvent: true
      //     }
      //   })
      // }
    },
    failedSubmitStripe () {
      this.isSubmittingForm = false
      this.$emit('done', false)
    },
    doneSubmitStripe () {
      this.$emit('done', true)
    },
    checkCardsIfAvail () {
      this.existingPayments = this.$store.state.cards.list
      if (this.existingPayments.length) {
        this.showPaymentDropdown = this.existingPayments.length
        this.isPaymentFormHidden = true
        this.selectedPayment = -1
      }
    },
    clearStripeForm () {
      this.selectedPayment = '0'
      this.existingPayments = []
      this.showPaymentDropdown = false
      this.isPaymentFormHidden = false
      if (this.$refs.stripeForm) this.$refs.stripeForm.clearFields()
    }
  },
  watch: {
    _token (val) {
      if (!val) {
        this.selectedPayment = -1
        this.existingPayments = []
      }
    },
    _cards (val) {
      if (val) this.existingPayments = val
    }
  },
  mounted () {
    if (this.bookingType === 'flight') {
      // if (!this.$store.state.user.token && !this.bookingAsGuest) {
      //   this.$root.$router.push('pax-info')
      //   return
      // }
    } else {
      if (this.user === null && !this.isCorporate) {
        this.$root.$router.push('customer')
        return
      }
    }

    this.$store.commit('setCurrentIndex', 2)
    this.$store.commit('enablePreviousSteps', 2)

    this.$store.commit('setShowPaymentBreakdown', true)
    this.$store.commit('setShowPromoCodeInput', true)

    this.showPaymentDropdown = true
    if (!this.$store.state.cards.list.length) {
      this.showPaymentDropdown = false
      this.isPaymentFormHidden = false
      this.selectedPayment = '0'
    } else {
      this.existingPayments = this.$store.state.cards.list
    }

    let self = this
    this.$root.$on('getCardsSuccess', function (cards) {
      self.existingPayments = []

      if (typeof cards === 'undefined' || cards.length === 0) {
        self.showPaymentDropdown = false
        self.isPaymentFormHidden = false
        self.selectedPayment = '0';
      } else {
        for (let i = 0; i < cards.length; i++) {
          let card = cards[i]
          let className = self.parseCardClass(card)

          self.existingPayments.push({
            id: card.ID,
            type: card.title,
            number: card.cardNumber,
            exp: card.cardExpires,
            className: className
          })
        }
        self.showPaymentDropdown = true
        self.$store.commit('cards/setCardData', {
          lastUserID: self.$store.state.user.id,
          list: self.existingPayments
        })
      }
    })

    this.$root.$on('getCardsFail', function (cards) {
      self.showPaymentDropdown = false
      self.isPaymentFormHidden = false
      self.selectedPayment = '0'
    })

    // this.$root.$emit('getCards')

    this.$root.$on('addCardSuccess', function (response) {
      self.showCreditCardError = false
      self.isSubmittingForm = false

      let card = response.data.card
      let className = self.parseCardClass(card)
      let selectedCard = {
        id: card.ID,
        type: card.title,
        number: card.cardNumber,
        exp: card.cardExpires,
        className: className
      }

      self.$store.commit('setSelectedCard', selectedCard)
      self.trackPaymentData()
      if (self.bookingType === 'flight') {
        self.$emit('done', true)
        // self.$root.$router.push('review-summary')
      } else {
        self.$root.$router.push('review')
      }
      if (/*CONFIG.Env == 'production' &&*/ window.gtag) { // eslint-disable-line
        gtag('event', 'Payment Continue') // eslint-disable-line
      }
    })

    this.$root.$on('addCardFail', function (response) {
      self.isSubmittingForm = false
      self.showCreditCardError = true

      let errorMsg = response.message
      if (typeof response.message === 'object') {
        errorMsg = response.message.message
      }
      self.creditCardError = errorMsg
      self.$emit('done', false)
    })

    // if (this.$ga) {
    //   this.$ga.page({
    //     page: '/payment',
    //     title: 'Payment Page',
    //     screenName: 'paymentPage'
    //   })
    // }
    // if (window.gtag) { // eslint-disable-line
    //   gtag('event', 'page_view', { // eslint-disable-line
    //     'page': 'Payment page'
    //   })
    // }

    let elmnt = document.getElementById('app')
    elmnt.scrollIntoView({behavior: 'smooth', block: 'start'})
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/CreditCardIcons.css";
@import "../../assets/scss/CreditCardIcons.scss";
@import "../../assets/scss/Payment/PaymentForm.scss";

h2{ font-size: 1.5em!important; }
.fa-icon {
  width: auto;
  height: 1em; /* or any other relative font sizes */
}
.op-btn, .op-btn:not(.loading) .original-label{ display: inline-flex!important; } /* cross browser fix */

.btnContinue, .btnBack{
  text-decoration: none!important;
}
.pad-b{
  padding-bottom: 30px;
}

.card.payment-card{
  border: 1px solid #abb2b8;
  border-radius: 6px;
  background: #fff;
  margin-bottom: 30px;
}
.payment-form-header{
  background: #dde1e6;
  letter-spacing: .5px;
  padding: 15px 20px;
  border-radius: 6px 6px 0 0;

  svg{
    margin-right: 10px;
  }
  span{
    font-size: 16px;
    line-height: 1;
  }
}
</style>



// WEBPACK FOOTER //
// PaymentForm.vue?0e3ed2fe